import { render } from "./FieldRules.vue?vue&type=template&id=38aef318&scoped=true&ts=true"
import script from "./FieldRules.vue?vue&type=script&lang=ts"
export * from "./FieldRules.vue?vue&type=script&lang=ts"

import "./FieldRules.vue?vue&type=style&index=0&id=38aef318&lang=scss&scoped=true"

import exportComponent from "C:\\TeamCityBuildAgent\\work\\623dcfb411009e26\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38aef318"]])

export default __exports__